import { FC } from "react";
import { Space as AntSpace, SpaceProps as AntSpaceProps } from "antd";
import { clsx } from "clsx";
import classes from "./Space.module.less";

export interface SpaceProps extends AntSpaceProps {
    fullWidth?: boolean;
}

export const Space: FC<SpaceProps> = ({ fullWidth, className, ...props }) => {
    return (
        <AntSpace
            className={clsx(fullWidth && classes[`Space--fullWidth`], className)}
            {...props}
        />
    );
};

Space.displayName = "Space";
